import axios from "axios";

export default function CountryListService() {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/country",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
